<template>
  <div class="w-full landing flex flex-col gap-4">
    <Navbar />
    <div class="head-cont mb-6">
      <h1 class="text-5xl font-semibold">Decast Features</h1>
    </div>

    <div class="basic__section basic__section__1 flex w-full justify-center items-center py-16">
      <div
        class="max-w-5xl w-full lg:px-16 md:px-6 p-4 flex flex-col lg:grid lg:grid-flow-col grid-cols-2 justify-between items-start lg:gap-4 gap-16">
        <div class="flex flex-col text-grey gap-4 w-full col-span-1 lg:order-last lg:justify-end lg:items-end">
          <div class="flex-col flex md:w-10/12 sm:w-10/12">
            <div class="w-24 h-24 relative mb-4 pr-2">
              <img class="w-full h-full" src="@/assets/images/landing/features/featureicon1.svg" />
            </div>
            <h5 class="lg:text-5xl text-4xl text-grey font-semibold">
              AI-Enhanced Video Editing
            </h5>
            <div class="w-64 my-4 h-2 rounded-full" style="background-color: #d7df23"></div>
            <p class="text-base text-grey font-normal">
              Implement advanced AI algorithms for video editing that can automatically identify key moments, suggest
              edits, and enhance video quality.
            </p>
          </div>
        </div>
        <div class="basic__section__img w-full md:w-auto relative flex object-cover col-span-1 justify-start">
          <img class="rounded-lg object-cover sm:w-10/12 w-full" src="@/assets/images/landing/features/features1.png" />
        </div>
      </div>
    </div>

    <div class="basic__section basic__section__2 flex w-full justify-center items-center py-16">
      <div
        class="max-w-5xl w-full lg:px-16 md:px-6 p-4 flex flex-col lg:grid lg:grid-flow-col grid-cols-2 justify-between items-start lg:gap-4 gap-16">
        <div class="flex flex-col text-grey gap-4 w-full col-span-1">
          <div class="w-24 h-24 relative mb-4 pr-2">
            <img class="w-full h-full" src="@/assets/images/landing/features/featureicon2.svg" />
          </div>
          <h5 class="lg:text-5xl text-4xl text-grey font-semibold md:w-10/12 sm:w-10/12">
            Blockchain for Content Authentication
          </h5>
          <div class="w-64 my-4 h-2 rounded-full" style="background-color: #d7df23"></div>
          <p class="text-base text-grey font-normal md:w-10/12 sm:w-10/12">
            Use blockchain technology to timestamp and authenticate video records, ensuring its integrity, originality,
            and preventing tampering or unauthorized distribution.
          </p>
        </div>
        <div class="basic__section__img w-full md:w-auto relative flex object-cover col-span-1 justify-end">
          <img class="rounded-lg object-cover sm:w-10/12 w-full" src="@/assets/images/landing/features/features2.png" />
        </div>
      </div>
    </div>

    <div class="basic__section basic__section__1 flex w-full justify-center items-center py-16">
      <div
        class="max-w-5xl w-full lg:px-16 md:px-6 p-4 flex flex-col lg:grid lg:grid-flow-col grid-cols-2 justify-between items-start lg:gap-4 gap-16">
        <div class="flex flex-col text-grey gap-4 w-full col-span-1 lg:order-last lg:justify-end lg:items-end">
          <div class="flex-col flex md:w-10/12 sm:w-10/12">
            <div class="w-24 h-24 relative mb-4 pr-2">
              <img class="w-full h-full" src="@/assets/images/landing/features/featureicon3.svg" />
            </div>
            <h5 class="lg:text-5xl text-4xl text-grey font-semibold">
              Real-time Language Translation
            </h5>
            <div class="w-64 my-4 h-2 rounded-full" style="background-color: #d7df23"></div>
            <p class="text-base text-grey font-normal">
              Implement an AI-powered real-time language translation feature that automatically translates spoken words
              into multiple languages during video conferences or in recorded content.
            </p>
          </div>
        </div>
        <div class="basic__section__img w-full md:w-auto relative flex object-cover col-span-1 justify-start">
          <img class="rounded-lg object-cover sm:w-10/12 w-full" src="@/assets/images/landing/features/features3.png" />
        </div>
      </div>
    </div>

    <div class="basic__section basic__section__2 flex w-full justify-center items-center py-16">
      <div
        class="max-w-5xl w-full lg:px-16 md:px-6 p-4 flex flex-col lg:grid lg:grid-flow-col grid-cols-2 justify-between items-start lg:gap-4 gap-16">
        <div class="flex flex-col text-grey gap-4 w-full col-span-1">
          <div class="w-24 h-24 relative mb-4 pr-2">
            <img class="w-full h-full" src="@/assets/images/landing/features/featureicon4.svg" />
          </div>
          <h5 class="lg:text-5xl text-4xl text-grey font-semibold md:w-10/12 sm:w-10/12">
            Energy-Efficient Streaming
          </h5>
          <div class="w-64 my-4 h-2 rounded-full" style="background-color: #d7df23"></div>
          <p class="text-base text-grey font-normal md:w-10/12 sm:w-10/12">
            Energy-efficient networked streaming solutions over distributed decentralized infrastructure that optimizes
            bandwidth usage, reduce environmental impact, and ensure a sustainable video infrastructure.
          </p>
        </div>
        <div class="basic__section__img w-full md:w-auto relative flex object-cover col-span-1 justify-end">
          <img class="rounded-lg object-cover sm:w-10/12 w-full" src="@/assets/images/landing/features/features4.png" />
        </div>
      </div>
    </div>

    <div class="basic__section basic__section__1 flex w-full justify-center items-center py-16">
      <div
        class="max-w-5xl w-full lg:px-16 md:px-6 p-4 flex flex-col lg:grid lg:grid-flow-col grid-cols-2 justify-between items-start lg:gap-4 gap-16">
        <div class="flex flex-col text-grey gap-4 w-full col-span-1 lg:order-last lg:justify-end lg:items-end">
          <div class="flex-col flex md:w-10/12 sm:w-10/12">
            <div class="w-24 h-24 relative mb-4 pr-2">
              <img class="w-full h-full" src="@/assets/images/landing/features/featureicon5.svg" />
            </div>
            <h5 class="lg:text-5xl text-4xl text-grey font-semibold">
              Post event Analytics for Content Recommendations
            </h5>
            <div class="w-64 my-4 h-2 rounded-full" style="background-color: #d7df23"></div>
            <p class="text-base text-grey font-normal">
              Utilize post cast analytics to understand audience participation and preferences, offering personalized
              content recommendations and improving the overall user experience.
            </p>
          </div>
        </div>
        <div class="basic__section__img w-full md:w-auto relative flex object-cover col-span-1 justify-start">
          <img class="rounded-lg object-cover sm:w-10/12 w-full" src="@/assets/images/landing/features/features5.png" />
        </div>
      </div>
    </div>
    <FootSec />
  </div>
</template>

<script>
import Navbar from './Navbar.vue';
import FootSec from './FootSec.vue';
export default {
  components: {
    Navbar,
    FootSec,
  },
};
</script>

<style scoped>
.landing {
  height: auto;
  width: 100%;
  background-image: linear-gradient(180deg, #000, #111, #222);
  font-family: 'Montserrat' !important;
  /* overflow-x: hidden; */
  /* background: -webkit-linear-gradient(to bottom,#302f2f,#222121);
  background: linear-gradient(to bottom,#000000,#000000,#000000,#1d1c1c,#141318,#181a20,#222121);  */
}

.basic__section__1 {
  background-image: url('../assets/images/leftPart.svg');
  background-position: left;
  background-repeat: no-repeat;
  background-size: contain;
}

.basic__section__2 {
  background-image: url('../assets/images/rightPart.svg');
  background-position: right;
  background-repeat: no-repeat;
  background-size: contain;
}

.basic__section__img img {
  box-shadow: 50px 50px 100px -12px rgba(214, 224, 36, 0.1);
  transition: all 0.5s ease-in-out;
}

.basic__section__img img:hover {
  box-shadow: 50px 50px 80px -12px rgba(214, 224, 36, 0.2);
}

.head-cont {
  background-color: #d7df23;
  width: 100%;
  min-height: 25vh;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
